import { render, staticRenderFns } from "./social.vue?vue&type=template&id=45379251&scoped=true&"
import script from "./social.vue?vue&type=script&lang=js&"
export * from "./social.vue?vue&type=script&lang=js&"
import style0 from "./social.vue?vue&type=style&index=0&id=45379251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45379251",
  null
  
)

export default component.exports